export default "__VITE_ASSET__Ltqggk8u__"